import { useContext, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useValue } from '@hooks/useValue'
import { useFinality } from '@api/finality'

import { CardDeliverySendPaymentUI } from './ui'
import { ICardDeliverySendPaymentContainer, ICardDeliverySendPaymentUI, ICreateList, IPaymentFilesList } from './types'

import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'


/** Контейнер отправки счёта в telegram */
export const CardDeliverySendPaymentContainer = ({ isOpen, cardID, contractTypeID, handleBtnOk, handleBtnCancel }: ICardDeliverySendPaymentContainer) => {
    const notify = useContext(NotificationContext)

    const { isLoadingCardFiles, getFiles, sendPayment } = useFinality(useShallow((state) => ({
        isLoadingCardFiles: state.isLoadingCardFiles,
        
        getFiles: state.actionGetPaymentFilesOnContract,
        sendPayment: state.actionTelegramPaymentInvoiceToClint,
    })))

    const loadingTitle = useValue<string>('Загрузка файлов...')

    const filesList = useValue<IPaymentFilesList[]>([])
    const createList = useValue<ICreateList[]>([])

    useEffect(() => {
        if (isOpen) {
            getFiles(Number(cardID)).then((res) => {
                if (res) {
                    filesList.setValue(res.map((item) => ({
                        name: item.fileName,
                        isSelect: false
                    })))
                }
            })

            createList.setValue(
                contractTypeID === 1
                    ? [
                        { id: 1, name: 'Счёт за месяц', isSelect: false },
                        { id: 2, name: 'Итоговый-счёт', isSelect: false }
                    ]
                    : [{ id: 2, name: 'Итоговый-счёт', isSelect: false }]
            )
        }

        !isOpen && clearCard() // Обнуление данных по анкете
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    /** Функция очистки данных */
    const clearCard = () => {
        loadingTitle.setValue('Загрузка файлов...')

        filesList.setValue([])
        createList.setValue([])
    }


    /** Функция по выбору файлов счетов */
    const handleSelectedFiles = (fileName: string) => {
        const resetList = createList.value.map(item => {
            return { ...item, isSelect: false }
        })
        createList.setValue(resetList)

        const newList = filesList.value.map(item => {
            if (item.name === fileName) {
                return { ...item, isSelect: !item.isSelect }
            }

            return item
        })
        
        filesList.setValue(newList)
    }
    /** Функция по выбору тип создаваемого счета */
    const handleSelectedPayment = (stringID: number) => {
        const resetList = filesList.value.map(item => {
            return { ...item, isSelect: false }
        })
        filesList.setValue(resetList)

        const newList = createList.value.map(item => {
            return { ...item, isSelect: item.id === stringID }
        })

        createList.setValue(newList)
    }


    /** Кнопка отправить выбранное */
    const handleBtnSend = () => {
        let paymentInvoiceType: number = 0
        let filesToSend: string[] = []

        /** Вычисляю выбранный идентификатор типа создаваемого счета (Счёт за меся или Итоговый счёт) */
        const selectedPaymentType = createList.value.filter((item) => item.isSelect === true)
        if (selectedPaymentType.length > 0) paymentInvoiceType = selectedPaymentType[0].id

        /** Вычисляем выбранные файлы счетов для отправки, если таковые имеются */
        filesList.value.forEach(item => { if (item.isSelect) filesToSend.push(item.name) })

        /** Проверяю, если не выбрано ни чего, то вывожу сообщение пользователю */
        if (paymentInvoiceType === 0 && filesToSend.length === 0) return notify && notifyOpen('Необходимо выбрать, уже имеющиеся файлы счетов или один из типов для создания счёта.', 'warning', 1500, notify)


        loadingTitle.setValue('Отправляю счета, ожидайте...')

        sendPayment(Number(cardID), paymentInvoiceType, filesToSend).then(res => {
            if (res === 200) notify && notifyOpen('Счета успешно отправлены!', 'success', 1500, notify)
        }).finally(() => {
            loadingTitle.setValue('Загрузка файлов...')
            
            getFiles(Number(cardID)).then((res) => {
                if (res) {
                    filesList.setValue(res.map((item) => ({
                        name: item.fileName,
                        isSelect: false
                    })))
                }
            })
        })
    }



    /** Свойства передаваемые в UI */
    const propsUI: ICardDeliverySendPaymentUI = {
        isOpen, loadingTitle,
        isLoadingFiles: isLoadingCardFiles, 
        filesList, createList,

        handleSelectedFiles, handleSelectedPayment,
        handleBtnSend, handleBtnCancel
    }
    
    return <>
        <CardDeliverySendPaymentUI {...propsUI} />
    </>
}